export default "__VITE_ASSET__BrFs5vRi__"